module.exports = __webpack_public_path__ + "img/1280.3cf751c0.svg";